export const SORT_BY_OPTIONS = [
  {
    label: 'Relevance',
    value: 'relevance',
  },
  {
    label: 'Hourly rate low to high',
    value: 'hourlyRateLowToHigh',
  },
  {
    label: 'Hourly rate high to low',
    value: 'hourlyRateHighToLow',
  },
  {
    label: 'Experience least to most',
    value: 'yoeLowToHigh',
  },
  {
    label: 'Experience most to least',
    value: 'yoeHighToLow',
  },
];

export const SORT_BY_OPTION_VALUES = [
  'relevance',
  'hourlyRateLowToHigh',
  'hourlyRateHighToLow',
  'yoeLowToHigh',
  'yoeHighToLow',
] as const;

export const TALENT_SEARCH_PAGE_SIZE = 12;
